import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import generateId from './generateId';
import { updateHashProps, rewriteUserId } from '../general';
import { addDatasToSave, loadDbModel } from './workBackendSlice';
import { saveAllData, saveData, deleteData, SignUpPayload } from './dataBackend';

export type FolderDb = {
  name: string
}
const initial: FolderDb = {
  name: ''
};

export type FolderDbHashType = {
  [key in string]: FolderDb;
}

export type FolderAddPayload = {
  id?: string;
} & FolderDb;
export type FolderUpdatePayload = {
  id: string;
} & { [P in keyof FolderDb]?: FolderDb[P] };

export type FolderDbState = {
  folders: FolderDbHashType;
  currentFolderId: string | null;
}

export const  generateFolderId = () : string => generateId('f');
let initialState: FolderDbState = { folders: {}, currentFolderId: null };
const key = 'folders';

const folderDbSlice = createSlice({
  name: 'folderDb',
  initialState,
  reducers: {
    initializeFolders(state: FolderDbState) {
      state.folders = {};
    },
    addFolder(state: FolderDbState, action: PayloadAction<FolderAddPayload>) {
      let { id, ...obj } = action.payload;
      if (!id) id = generateFolderId();
      state.folders[id] = obj;
      saveData(key, id, obj);
    },
    updateFolder(state: FolderDbState, action: PayloadAction<FolderUpdatePayload>) {
      const { id, ...obj } = action.payload;
      if (state.folders[id] === undefined) {
        console.log(`*** Folder not found: ${id}`);
      } else {
        const newData = { ...state.folders[id], ...obj };
        state.folders[id] = newData;
        saveData(key, id, newData);
      }
    },
    deleteFolder(state: FolderDbState, action: PayloadAction<FolderUpdatePayload>) {
      const id = action.payload.id;
      delete state.folders[id];
      deleteData(key, id);
    },
    saveFolders(state: FolderDbState) {
      saveAllData(key, state.folders);
    },
    setCurrentFolder(state: FolderDbState, action: PayloadAction<string | null>) {
      state.currentFolderId = action.payload;
    },
    signUpFolders(state: FolderDbState, action: PayloadAction<SignUpPayload>) {
      const values = rewriteUserId(state.folders, action.payload);
      addDatasToSave(key, values);
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loadDbModel(key).fulfilled, (state: FolderDbState, action) => {
      const values = action.payload;
      const [changed, updatedValues] = updateHashProps(initial, values);
      state.folders = updatedValues;
      if (changed) saveAllData(key, state.folders);
    })
  }
})

export const { initializeFolders, addFolder, updateFolder, deleteFolder, saveFolders, setCurrentFolder, signUpFolders } = folderDbSlice.actions;
export default folderDbSlice.reducer;
